module.exports = __webpack_public_path__ + "img/launching.f17d1bc7.webp";